"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConfirmationModal = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const react_jss_1 = __importDefault(require("react-jss"));
const modals_1 = require("../../utils/modals");
const __1 = require("..");
const confirmationModal_style_1 = __importDefault(require("./confirmationModal.style"));
const DEFAULT_CONFIRM_BTN_LABEL = 'confirm';
/**
 * @param content - you can pass simplified markdown
 * - for bold: wrap the text with **
 * - for a line break: add <br>
 * @param title - supports bold only
 */
const ConfirmationModal = ({ classes, title, content, confirmBtnText = '', confirm, cancel, warning = false }) => {
    const proseContent = react_1.useMemo(() => modals_1.parseModalContent(content), [content]);
    return (jsx_runtime_1.jsxs(__1.Modal, Object.assign({ title: title, closeButtonLabel: "Cancel", handleCollapse: cancel }, { children: [jsx_runtime_1.jsx(__1.ModalContent, { children: jsx_runtime_1.jsx("div", Object.assign({ className: classes.modalContent }, { children: proseContent }), void 0) }, void 0),
            jsx_runtime_1.jsx(__1.ModalActions, Object.assign({ adverseAction: jsx_runtime_1.jsx(__1.Pushbutton, Object.assign({ onClick: cancel, dataCy: "cancel-button" }, { children: "cancel" }), void 0) }, { children: jsx_runtime_1.jsx(__1.Pushbutton, Object.assign({ warning: warning, primary: !warning, onClick: confirm, dataCy: "confirm-button" }, { children: confirmBtnText || DEFAULT_CONFIRM_BTN_LABEL }), void 0) }), void 0)] }), void 0));
};
exports.ConfirmationModal = ConfirmationModal;
exports.default = react_jss_1.default(confirmationModal_style_1.default)(react_1.memo(exports.ConfirmationModal));
//# sourceMappingURL=index.js.map